// How a person is shown in the interface. The username is an internal id and is
// only shown as a last resort, for old accounts that have neither a name nor a nickname.
export const displayName = (user) => {
    if (!user) return ""
    const fullName = [user.name, user.last_name, user.father_name].filter(Boolean).join(" ").trim()
    if (fullName) return fullName
    if (user.nickname) return `@${user.nickname}`
    return user.username || ""
}

// "@nickname" shown under/next to the name, empty when no nickname is set
export const nicknameLabel = (user) => (user?.nickname ? `@${user.nickname}` : "")
